module.exports = __webpack_public_path__ + "static/RootSans-8SemiBoldItalic-0dd56941a471f5d34d376e8a47696c9c.woff2";